declare namespace $ {

	type $mol_check_icon__checked_bog_wikilive_tree_node_1 = $mol_type_enforce<
		ReturnType< $bog_wikilive_tree_node['expanded'] >
		,
		ReturnType< $mol_check_icon['checked'] >
	>
	type $mol_check_icon__Icon_bog_wikilive_tree_node_2 = $mol_type_enforce<
		ReturnType< $bog_wikilive_tree_node['Expand_icon'] >
		,
		ReturnType< $mol_check_icon['Icon'] >
	>
	type $mol_button_minor__title_bog_wikilive_tree_node_3 = $mol_type_enforce<
		ReturnType< $bog_wikilive_tree_node['title'] >
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_wikilive_tree_node_4 = $mol_type_enforce<
		ReturnType< $bog_wikilive_tree_node['select'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_drag__Sub_bog_wikilive_tree_node_5 = $mol_type_enforce<
		ReturnType< $bog_wikilive_tree_node['Title'] >
		,
		ReturnType< $mol_drag['Sub'] >
	>
	type $mol_drag__transfer_bog_wikilive_tree_node_6 = $mol_type_enforce<
		({ 
			'text/plain': ReturnType< $bog_wikilive_tree_node['page_link'] >,
			'text/html': string,
			'text/uri-list': string,
		}) 
		,
		ReturnType< $mol_drag['transfer'] >
	>
	type $mol_view__sub_bog_wikilive_tree_node_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_drop__Sub_bog_wikilive_tree_node_8 = $mol_type_enforce<
		ReturnType< $bog_wikilive_tree_node['Row'] >
		,
		ReturnType< $mol_drop['Sub'] >
	>
	type $mol_drop__receive_bog_wikilive_tree_node_9 = $mol_type_enforce<
		ReturnType< $bog_wikilive_tree_node['drop_receive'] >
		,
		ReturnType< $mol_drop['receive'] >
	>
	type $mol_list__rows_bog_wikilive_tree_node_10 = $mol_type_enforce<
		ReturnType< $bog_wikilive_tree_node['child_nodes'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $bog_wikilive_tree_node__page_link_bog_wikilive_tree_node_11 = $mol_type_enforce<
		ReturnType< $bog_wikilive_tree_node['child_page_link'] >
		,
		ReturnType< $bog_wikilive_tree_node['page_link'] >
	>
	type $bog_wikilive_tree_node__store_bog_wikilive_tree_node_12 = $mol_type_enforce<
		ReturnType< $bog_wikilive_tree_node['store'] >
		,
		ReturnType< $bog_wikilive_tree_node['store'] >
	>
	type $bog_wikilive_tree_node__level_bog_wikilive_tree_node_13 = $mol_type_enforce<
		ReturnType< $bog_wikilive_tree_node['child_level'] >
		,
		ReturnType< $bog_wikilive_tree_node['level'] >
	>
	type $bog_wikilive_tree_node__page_selected_bog_wikilive_tree_node_14 = $mol_type_enforce<
		ReturnType< $bog_wikilive_tree_node['page_selected'] >
		,
		ReturnType< $bog_wikilive_tree_node['page_selected'] >
	>
	export class $bog_wikilive_tree_node extends $mol_view {
		Expand_icon( ): $mol_icon_chevron_right
		Expand( ): $mol_check_icon
		title( ): string
		select( next?: any ): any
		Title( ): $mol_button_minor
		Drag( ): $mol_drag
		Row( ): $mol_view
		drop_receive( next?: any ): any
		Drop( ): $mol_drop
		child_nodes( ): readonly(any)[]
		Children( ): $mol_list
		child_page_link( id: any): string
		child_level( ): number
		active( ): boolean
		store( ): $bog_wikilive_store
		page_link( ): string
		level( ): number
		page_selected( next?: string ): string
		expanded( next?: boolean ): boolean
		sub( ): readonly(any)[]
		Child_node( id: any): $bog_wikilive_tree_node
		attr( ): ({ 
			'bog_wikilive_tree_node_level': ReturnType< $bog_wikilive_tree_node['level'] >,
			'bog_wikilive_tree_node_active': ReturnType< $bog_wikilive_tree_node['active'] >,
		})  & ReturnType< $mol_view['attr'] >
	}
	
}

//# sourceMappingURL=node.view.tree.d.ts.map